import { Box, Stack, Typography } from "@mui/material";
import React from "react";

interface AdminEmptyStateProps {
  icon: React.ReactNode;
  text: React.ReactNode;
  description?: React.ReactNode;
}

/** Shared empty-state content for admin tables and their responsive card views. */
export const AdminEmptyState: React.FC<AdminEmptyStateProps> = ({ icon, text, description }) => {
  const isSimpleTitle = typeof text === "string" || typeof text === "number";

  return (
    <Stack alignItems="center" spacing={1} sx={{ py: 2, textAlign: "center" }}>
      <Box sx={{ display: "flex", color: "action.disabled" }}>{icon}</Box>
      {isSimpleTitle ? (
        <Typography variant="body1" sx={{ fontWeight: 600, color: "text.secondary" }}>
          {text}
        </Typography>
      ) : (
        <Box sx={{ color: "text.secondary", fontSize: "0.875rem" }}>{text}</Box>
      )}
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Stack>
  );
};
